import styled from "styled-components";

export const NotFoundContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: #f6f6f6;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const InfoContents = styled.div`
  padding: 24px 32px 24px 32px;
  height: 30%;
  width: 30%;
  background: #ffffff;
  box-shadow: 6.04275px 26.1419px 34.875px rgba(0, 0, 0, 0.04725),
    2.38726px 10.3277px 13px rgba(0, 0, 0, 0.035),
    0.522213px 2.25918px 4.625px rgba(0, 0, 0, 0.02275);
  border-radius: 12px;

  h1 {
    color: #1f2937;
    text-align: center;
  }

  //iphone SE
  @media screen and (min-width: 300px) and (max-width: 400px){
    width: 80%;
    height: 40%;
  }

  //iphone XR
  @media screen and (min-width: 400px) and (max-width: 500px){
    width: 80%;
    height: 30%;
  }

  //iphone 12 PRO
  @media screen and (min-width: 380px) and (max-width: 390px){
    width: 80%;
    height: 32%;
  }

  //ipad air
  @media screen and (min-width: 750px) and (max-width: 820px){
    width: 80%;
    height: 40%;

    h1 {
      padding: 50px 25px;
      font-size: 60px;
    }
  }

  //ipad mini
  @media screen and (min-width: 700px) and (max-width: 768px){
    width: 80%;
    height: 45%;

    h1 {
      padding: 50px 25px;
      font-size: 55px;
    }
  }

  @media screen and (min-width: 500px) and (max-width: 540px){
    width: 80%;
    height: 45%;

    h1 {
      padding: 10px 15px 25px 15px;
      font-size: 40px;
    }
  }

  @media screen and (min-width: 200px) and (max-width: 300px){
    width: 80%;
    height: 35%;

    h1 {
      padding: 0px 15px 35px 15px;
      font-size: 25px;
    }
  }

  @media screen and (min-width: 1000px) and (max-width: 1024px){
    width: 55%;
    height: 55%;

    h1 {
      padding: 25px 15px 35px 25px;
      font-size: 40px;
    }
  }

  @media screen and (min-width: 900px) and (max-width: 950px){
    width: 55%;
    height: 25%;

    h1 {
      padding: 25px 15px 35px 25px;
      font-size: 45px;
    }
  }
  `;

export const HeaderInfoContents = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 55px;

  @media screen and (min-width: 200px) and (max-width: 300px){
  margin-bottom: 40px;
  }
`;

export const LogoImg = styled.img`
  width: 96px;
  height: 41px;
`;